'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var statusMsg = require('./side-panel-status-msg');

var addEventHandlers = function() {

	console.log('buy-panel addEventHandlers called');

	appDom.document.on('click', '.package-detail__add-to-cart-btn', onAddPackageToCartBtnClicked);

};

var onAddPackageToCartBtnClicked = function(e) {

	var $el = $(this);

	e.preventDefault();

	$(this).text(window.pbizServer.content.loading);

	$.ajax({
		url: '?page=buy_packages_action',
		method: 'POST',
		dataType: 'JSON',
		data: {
			itemKey: $el.attr('data-item-key')
		}
	}).done(function(response) {

		renderPackageImagesPanel(response, false);

	});

};

var renderPackageImagesPanel = function(data, addedToCart) {

	$.ajax({
		url: '?page=buy_panel',
		method: 'POST',
		dataType: 'JSON',
		data: {
			activePanel: 'package_images',
			itemKey: data.itemKey
		}
	}).done(function(response) {

		sidePanel.open(response.markup, {retainScrollPosition: true});

		if (addedToCart) {
			statusMsg.show('added_to_cart');
		}

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
